import React from 'react';
import { BiCog, BiBarChartAlt2, BiLayer, BiFolder, BiBuilding, BiUser, BiFile, BiSearch, BiEdit, BiListUl, BiCheckCircle, BiXCircle, BiInfoCircle, BiLogoDropbox  } from 'react-icons/bi';

const TabNavigation = ({ 
  tabs, 
  activeTab, 
  onTabChange, 
  variant = 'default',
  className = '' 
}) => {
  // Mapeamento de ícones padrão
  const defaultIcons = {
    'config': BiCog,
    'chart': BiBarChartAlt2,
    'layer': BiLayer,
    'folder': BiFolder,
    'building': BiBuilding,
    'user': BiUser,
    'file': BiFile,
    'search': BiSearch,
    'edit': BiEdit,
    'list': BiListUl,
    'check': BiCheckCircle,
    'close': BiXCircle,
    'info': BiInfoCircle,
    'database': BiLogoDropbox ,
  };

  // Variantes de design
  const variants = {
         default: {
       container: "bg-white dark:bg-gray-900 rounded-xl shadow-lg",
       header: "bg-gradient-to-r from-vox-blue-50 to-vox-green-50 dark:from-gray-800 dark:to-gray-700 border-b border-gray-200 dark:border-gray-600",
       tab: "relative flex items-center gap-3 px-6 py-4 text-base md:text-lg font-semibold transition-all duration-300 whitespace-nowrap border-b-2 border-transparent hover:bg-white/50 dark:hover:bg-gray-700/50",
       activeTab: "text-vox-green-700 dark:text-vox-green-400 border-vox-green-500 bg-white dark:bg-gray-800 shadow-sm",
       inactiveTab: "text-gray-600 dark:text-gray-400 hover:text-vox-blue-600 dark:hover:text-white",
       activeIcon: "text-vox-green-600 dark:text-vox-green-400",
       inactiveIcon: "text-gray-500 dark:text-gray-400",
       indicator: "absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-vox-green-500 to-vox-blue-500"
     },
         minimal: {
       container: "bg-transparent",
       header: "border-b border-gray-200 dark:border-gray-600",
       tab: "relative flex items-center gap-3 px-4 py-3 text-base md:text-lg font-medium transition-all duration-200 whitespace-nowrap border-b-2 border-transparent hover:bg-gray-50 dark:hover:bg-gray-800",
       activeTab: "text-vox-blue-600 dark:text-vox-blue-400 border-vox-blue-500",
       inactiveTab: "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white",
       activeIcon: "text-vox-blue-600 dark:text-vox-blue-400",
       inactiveIcon: "text-gray-500 dark:text-gray-400",
       indicator: "absolute bottom-0 left-0 right-0 h-0.5 bg-vox-blue-500"
     },
         card: {
       container: "bg-white dark:bg-gray-800 rounded-lg shadow-md",
       header: "bg-gray-50 dark:bg-gray-700 rounded-t-lg border-b border-gray-200 dark:border-gray-600",
       tab: "relative flex items-center gap-3 px-4 py-3 text-base md:text-lg font-medium transition-all duration-200 whitespace-nowrap border-b-2 border-transparent hover:bg-white dark:hover:bg-gray-600",
       activeTab: "text-vox-green-600 dark:text-vox-green-400 border-vox-green-500 bg-white dark:bg-gray-600",
       inactiveTab: "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white",
       activeIcon: "text-vox-green-600 dark:text-vox-green-400",
       inactiveIcon: "text-gray-500 dark:text-gray-400",
       indicator: "absolute bottom-0 left-0 right-0 h-0.5 bg-vox-green-500"
     }
  };

  const currentVariant = variants[variant] || variants.default;

  return (
    <div className={`${currentVariant.container} ${className}`}>
      {/* Header com abas */}
      <div className={currentVariant.header}>
        <div className="flex overflow-x-auto scrollbar-hide">
          {tabs.map((tab) => {
            const IconComponent = tab.icon ? defaultIcons[tab.icon] || tab.icon : null;
            
            return (
              <button
                key={tab.key}
                onClick={() => onTabChange(tab.key)}
                data-tour-id={`aba:${tab.key}`}
                className={`
                  ${currentVariant.tab}
                  ${activeTab === tab.key ? currentVariant.activeTab : currentVariant.inactiveTab}
                `}
              >
                                 {IconComponent && (
                   <IconComponent className={`w-5 h-5 md:w-6 md:h-6 transition-colors duration-200 ${
                     activeTab === tab.key ? currentVariant.activeIcon : currentVariant.inactiveIcon
                   }`} />
                 )}
                {tab.label}
                {activeTab === tab.key && (
                  <div className={currentVariant.indicator}></div>
                )}
              </button>
            );
          })}
        </div>
      </div>
      
      {/* Conteúdo da aba ativa */}
      <div className="p-6 tab-content-enter">
        {tabs.find(tab => tab.key === activeTab)?.content}
      </div>
    </div>
  );
};

export default TabNavigation;
